/**
 * "Futures 3×" beside a market, "Stocks" for SPY and QQQ, and nothing for an
 * unleveraged spot market — the default needs no label.
 *
 * A leveraged bot's return is not comparable with a spot bot's at face value:
 * 5× turns a 2% move into 10%, in both directions. Saying so wherever results
 * sit side by side (lists, the league, published backtests) is the cheapest
 * honest fix.
 */
function marketLabel(marketType: string | null | undefined, leverage: number | undefined): string | null {
  const lev = Math.max(1, Number(leverage ?? 1));
  if (marketType === "futures") return lev > 1 ? `Futures ${lev}×` : "Futures";
  if (marketType === "equity") return "Stocks";
  if (marketType === "forex") return "Forex";
  return lev > 1 ? `${lev}×` : null;
}

export function MarketTag({ marketType, leverage }: { marketType?: string | null; leverage?: number }) {
  const label = marketLabel(marketType, leverage);
  if (!label) return null;
  const futures = marketType === "futures";
  return (
    <span
      className={futures ? "badge badge--warn" : "badge"}
      title={
        futures
          ? Number(leverage ?? 1) > 1
            ? `USD-M futures at ${leverage}× leverage: gains and losses are ${leverage} times the price move, and a position can be liquidated`
            : "USD-M perpetual futures, no leverage"
          : undefined
      }
    >
      {label}
    </span>
  );
}
